<template>
  <v-card flat>
    <v-card-title>
      <v-btn-toggle
        ref="type"
        v-model="type"
        mandatory
      >
        <v-btn value="FEL" v-if="this.fel_id && this.app === 1 || this.app === 2">
          Usuarios FEL
        </v-btn>
        <v-btn value="PAC" v-if="this.pac_id && this.app === 3">
          Usuarios PAC
        </v-btn>
      </v-btn-toggle>
    </v-card-title>
    <v-card-text>
      <template>
        <v-row>
          <v-col cols="12">
          <vuetify-table
            :type="type"
            :headers="headers"
            :api-u-r-l="apiURL"
            :title="title"
            :query-params="queryParams"
            permisosNuevoRegistro="crear_usuario_empresa"
          >
        <template v-slot:actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="can('editar_usuario_empresa')"
                :color="themeColor"
                @click="editItem(item)"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom v-if="type != 'FEL'">
            <template v-slot:activator="{ on }">
              <v-icon
                :color="themeColor"
                @click="openModalDelete(item)"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
          <v-tooltip v-if="!restoringPassword" bottom >
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="can('restablecer_contrasena_usuario_empresa')"
                :color="themeColor"
                @click="openModalPass(item)"
                v-on="on"
              >
                mdi-lock
              </v-icon>
            </template>
            <span>Restablecer contraseña</span>
          </v-tooltip>
          <v-progress-circular
            v-else
            indeterminate
            :color="themeColor"
          ></v-progress-circular>
        </template>
      </vuetify-table>
      <v-dialog
        v-model="dialog"
        max-width="620"
      >
        <v-card>
          <v-card-title class="headline">
            ¿Estás seguro de que quieres eliminar este registro?
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="red darken-1"
              text
              @click="dialog = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="toggleStatus"
              @click.prevent="deleteItem()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogPass"
        max-width="650"
      >
        <v-card>
          <v-card-title class="headline">
            ¿Estás seguro de que quieres restablecer la contraseña de este registro?
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="red darken-1"
              text
              @click="dialogPass = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="toggleStatusPass"
              @click.prevent="resetPass()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import VuetifyTable from '~/components/VuetifyTable';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('enterprises') };
  },
  components: {
    VuetifyTable,
  },
  props: {
    id: { default: null },
    action: { default: '' },
    message: { default: '' },
    queryParams: {
      type: String,
    },
  },
  data: () => ({
      dialog: false,
      toggleStatus: false,
      dialogPass: false,
      toggleStatusPass: false,
      restoringPassword: false,
      fel_id: false,
      pac_id: false,
      app: '',
      headers: [
        {
          text: 'Nombre',
          value: 'name',
          align: 'left',
          sortable: true,
        }, {
          text: 'Email',
          value: 'email',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Estado',
          value: 'active',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Acciones',
          value: 'action',
          sortable: false,
        },
      ],
      titles: {
        FEL: 'Usuarios FEL',
        PAC: 'Usuarios PAC',
      },
      items: [],
      totalItems: 0,
      apiURLBase: '/api/enterprises',
      apiURLUser: 'users/type',
      type: 'FEL',
      name: '',
  }),
  computed: {
    ...mapGetters({
      themeColor: 'theme/themeColor',
    }),
    apiURL() {
      return `${this.apiURLBase}/${this.id}/${this.apiURLUser}/${this.type}`;
    },
    currentTitle() {
      return this.titles[this.type];
    },
    title() {
      return `${this.currentTitle}`;
    },
    enterprise() {
      return this.$store.state.profile.enterprise;
    },
  },
  mounted() {
    this.fel_id = this.enterprise.fel_id;
    this.pac_id = this.enterprise.pac_id;
    if (this.fel_id === null || this.fel_id === '' || this.fel_id === 0) {
      this.type = 'PAC';
    }
    this.app = this.enterprise.type;

    if (!this.can('cambiar_estado_usuario_empresa')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Estado'), 1);
    }
    if (!this.can('editar_usuario_empresa') && !this.can('restablecer_contrasena_usuario_empresa')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Acciones'), 1);
    }
  },
  methods: {
    editItem(item) {
      const editedItem = { ...item };
      this.$router.push({
          path: `${this.$router.currentRoute.path}/${editedItem.id}/${this.type}/editar`,
          params: { id: editedItem.id },
          });
    },
    openModalDelete(item) {
      this.dialog = true;
      this.item = item;
    },
    deleteItem() {
      const url = `${this.apiURL}/${this.item.id}`;
      window.axios.delete(url)
      .then((response) => {
        this.$store.dispatch('notifications/show', {
          message: response.data.message,
          type: response.data.type,
        });
        this.dialog = false;
      });
    },
    openModalPass(item) {
      this.dialogPass = true;
      this.item = item;
    },
    resetPass() {
      this.restoringPassword = true;
      window.axios.put(`${this.apiURLBase}/${this.enterprise.id}/${this.apiURLUser}/${this.type}/${this.item.id}/reset_password`, {
          id: this.item.id,
      }).then(() => {
        this.restoringPassword = false;
      });
      this.dialogPass = false;
    },
  },
};
</script>
